import { classNamePrefix } from '../globals';
import { TTitleLevel } from '../types';

export function renderTitle (title: string, level: TTitleLevel, id?: string) {
    const className = classNamePrefix + '-title';

    const titleElement = document.createElement(`h${level}`);
    titleElement.classList.add(className);
    titleElement.innerHTML = title;

    if (id) {
        titleElement.id = id;
    }

    return titleElement;
}